import Navigation from "../components/Navigation/Navigation";
import SecondaryNavigation from "../components/SecondaryNavigation/SecondaryNavigation"
import Table from "../components/Table/Table";
import { useState, useEffect, useContext } from "react";
import { context, } from '../context/authContext';
import useApi from '../helpers/api';
import ConfirmModal from "../components/Modal/Modal";

const columns=[
  { field: "id", sort: "desc"},
  { field: "api" },
  { field: "code" },
  { field: "detalle", flex: 3 },
  { field: "entidad" },
  { field: "idEntidad" },
  { field: "createdAt", flex: 2,
    valueFormatter: (params) =>{
      let date =  `${new Date(params.value).toLocaleDateString("en-GB")} 
      ${new Date(params.value).toLocaleTimeString("en-GB")}` 
      return date
    }
  } 
]


export default function Dashboard() {
  const [data, setData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modal, setModal] = useState({});
  const [login, setLogin] = useState(false);
  const { token } = useContext(context);
  const { handleLogout } = useContext(context);
  const api = useApi();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.logs();
        if (!!response.response) {
          if(!!response.response.data.error){
            handleLogout();
          }
        }
        setData(response)
      } catch (err) {
        console.log(err);
        handleLogout();
      }
    };

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleLogout, token, modalOpen]);

  const handleSyncContactos = async () => {
    try{
      setLogin(true)
      const result = await api.syncContactos();
      setLogin(false)
      setModal({
        header: 'Exito',
        message: result.mensaje,
        tipo: 'aviso',
      })
      setModalOpen(true)
    }catch(e){
      console.log(e)
    }
  }

  const handleSyncPresupuestos = async () => {
    try{
      setLogin(true)
      const result = await api.syncPresupuestos();
      setLogin(false)
      setModal({
        header: 'Exito',
        message: result.mensaje,
        tipo: 'aviso',
      })
      setModalOpen(true)
    }catch(e){
      console.log(e)
    }
  }

  return (
    <>
      <Navigation />
      <SecondaryNavigation title="Logs" />
      {data && (
        <Table columns={columns} data={data} login={login} handleSyncContactos={handleSyncContactos} handleSyncPresupuestos={handleSyncPresupuestos}/>
      )}
      <ConfirmModal
        isOpen={modalOpen}
        message={modal?.message}
        onConfirm={()=> setModalOpen(false)}
        onCancel={() => setModalOpen(false)}
        header={modal?.header}
        tipo={modal?.tipo}
      />
    </>
  );
}